import { useState } from "react";
import { useHistory } from "react-router-dom";
import { registerAccount } from "../../services/firebase";
import { toast } from "sonner";

export const CreateUser = () => {
  const history = useHistory();

  let [state, setState] = useState<any>({
    email: "",
    first_name: "",
    last_name: "",
    about: "",
    phone: "",
    street_address: "",
    state: "",
    city: "",
    country: "",
    zip: "",
    memberships: [],
    user_types: [],
    note: "",
    buttonDisabled: false,
  });

  const handleTextChange = (e: any) => {
    let field = e.target.name;
    setState({
      ...state,
      [field]: e.target.value,
      [field + "_errors"]: null,
    });
  };

  const handleInputChange = (e: any) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (value === true) {
      setState({
        ...state,
        user_types: [...state.user_types, name],
      });
    } else {
      var array = [...state.user_types];
      var index = array.indexOf(e.target.value);
      if (index !== -1) {
        array.splice(index, 1);
        setState({ user_types: array });
      }
    }
  };

  const submit = async (e: any) => {
    try {
      e.preventDefault();
      setState({ ...state, buttonDisabled: !state.buttonDisabled });
      setTimeout(
        () => setState({ buttonDisabled: !state.buttonDisabled }),
        5000
      );

      let data = {
        email: state.email,
        first_name: state.first_name,
        last_name: state.last_name,
        about: state.about,
        phone: state.phone,
        addresses: [
          {
            street_address: state.street_address,
            state: state.state,
            city: state.city,
            country: state.country,
            zip: state.zip,
          },
        ],
        memberships: [],
        user_types: state.user_types,
        note: state.note,
      };
      registerAccount(data)
        .then(() => {
          toast.success("registered", { duration: 5000 });
          return history.push({
            pathname: "/users",
          });
        })
        .catch((e) => {
          toast.error(e.message, { duration: 5000 });
        });
    } catch (e) {
      console.log(e);
    }
  };

  function getCountries() {
    let countries = ["", "Philippines", "India", "United States of America"];
    return countries.map((country, index) => {
      return <option key={index}>{country}</option>;
    });
  }

  return (
    <div className="p-8 flex justify-center">
      <form className="space-y-8 divide-y divide-gray-200">
        <div className="space-y-8 divide-y divide-gray-200">
          <div>
            <div>
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Create User
              </h3>
            </div>
          </div>

          <div className="pt-8">
            <div>
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Personal Information
              </h3>
            </div>
            <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div className="sm:col-span-3">
                <label
                  htmlFor="first_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  First name
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="first_name"
                    id="first_name"
                    autoComplete="given-name"
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    onChange={handleTextChange}
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  htmlFor="last_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Last name
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="last_name"
                    id="last_name"
                    autoComplete="family-name"
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    onChange={handleTextChange}
                  />
                </div>
              </div>

              <div className="sm:col-span-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    onChange={handleTextChange}
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  htmlFor="country"
                  className="block text-sm font-medium text-gray-700"
                >
                  Country / Region
                </label>
                <div className="mt-1">
                  <select
                    id="country"
                    name="country"
                    autoComplete="country"
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  >
                    {getCountries()}
                  </select>
                </div>
              </div>

              <div className="sm:col-span-6">
                <label
                  htmlFor="street_address"
                  className="block text-sm font-medium text-gray-700"
                >
                  Street address
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="street_address"
                    id="street_address"
                    autoComplete="street-address"
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    onChange={handleTextChange}
                  />
                </div>
              </div>

              <div className="sm:col-span-2">
                <label
                  htmlFor="city"
                  className="block text-sm font-medium text-gray-700"
                >
                  City
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="city"
                    id="city"
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    onChange={handleTextChange}
                  />
                </div>
              </div>

              <div className="sm:col-span-2">
                <label
                  htmlFor="state"
                  className="block text-sm font-medium text-gray-700"
                >
                  State / Province
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="state"
                    id="state"
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    onChange={handleTextChange}
                  />
                </div>
              </div>

              <div className="sm:col-span-2">
                <label
                  htmlFor="zip"
                  className="block text-sm font-medium text-gray-700"
                >
                  ZIP / Postal
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="zip"
                    id="zip"
                    autoComplete="postal-code"
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    onChange={handleTextChange}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="pt-8 sm:col-span-6">
            <label
              htmlFor="about"
              className="block text-sm font-medium text-gray-700"
            >
              Notes
            </label>
            <div className="mt-1">
              <textarea
                id="notes"
                name="notes"
                rows={3}
                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                defaultValue={""}
                onChange={handleTextChange}
              />
            </div>
            <p className="mt-2 text-sm text-gray-500">
              Write a few sentences about them.
            </p>
          </div>

          <div className="pt-8">
            <div className="mt-6">
              <fieldset>
                <legend className="text-base font-medium text-gray-900">
                  Permissions
                </legend>
                <div className="mt-4 space-y-4">
                  <div className="relative flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="admin"
                        name="admin"
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        onClick={handleInputChange}
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label
                        htmlFor="admin"
                        className="font-medium text-gray-700"
                      >
                        Admin
                      </label>
                      <p className="text-gray-500">Access to everything</p>
                    </div>
                  </div>

                  <div className="relative flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="director"
                        name="director"
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        onClick={handleInputChange}
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label
                        htmlFor="director"
                        className="font-medium text-gray-700"
                      >
                        Director
                      </label>
                      <p className="text-gray-500">
                        Access to everything except developer tools
                      </p>
                    </div>
                  </div>

                  <div className="relative flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="manager"
                        name="manager"
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        onClick={handleInputChange}
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label
                        htmlFor="manager"
                        className="font-medium text-gray-700"
                      >
                        Manager
                      </label>
                      <p className="text-gray-500">Staff management</p>
                    </div>
                  </div>

                  <div className="relative flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="designer"
                        name="designer"
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        onClick={handleInputChange}
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label
                        htmlFor="designer"
                        className="font-medium text-gray-700"
                      >
                        Designer
                      </label>
                      <p className="text-gray-500">
                        Create designs, communicate with campaign managers
                      </p>
                    </div>
                  </div>

                  <div className="relative flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="support"
                        name="support"
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        onClick={handleInputChange}
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label
                        htmlFor="support"
                        className="font-medium text-gray-700"
                      >
                        Customer Support
                      </label>
                      <p className="text-gray-500">
                        Communicate with campaign managers and vendors
                      </p>
                    </div>
                  </div>

                  <div className="relative flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="vendor"
                        name="vendor"
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        onClick={handleInputChange}
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label
                        htmlFor="vendor"
                        className="font-medium text-gray-700"
                      >
                        Vendor
                      </label>
                      <p className="text-gray-500">
                        Access to the vendor portal
                      </p>
                    </div>
                  </div>

                  <div className="relative flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="campaign"
                        name="campaign"
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        onClick={handleInputChange}
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label
                        htmlFor="campaign"
                        className="font-medium text-gray-700"
                      >
                        Campaign Manager
                      </label>
                      <p className="text-gray-500">Create Campaigns</p>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>

        <div className="pt-5">
          <div className="flex justify-end">
            <button
              type="button"
              className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              onClick={submit}
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
